import React, { useState, useEffect } from 'react';
import { ref, onValue, push, remove } from 'firebase/database';
import { db } from '../../firebase';
import { Announcement } from '../../types';

const fmt = (ts: number) =>
  new Date(ts).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const AnnouncementsTab: React.FC = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ title: '', body: '', important: false });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    return onValue(ref(db, 'announcements'), snap => {
      const d = snap.val();
      setAnnouncements(d
        ? Object.entries(d).map(([id, v]) => ({ id, ...(v as Announcement) })).sort((a, b) => b.createdAt - a.createdAt)
        : []);
    });
  }, []);

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    await push(ref(db, 'announcements'), { ...form, createdAt: Date.now() });
    setForm({ title: '', body: '', important: false });
    setAdding(false);
    setSaving(false);
  };

  const handleDelete = async (id: string) => {
    if (window.confirm('Bu duyuruyu silmek istediğinizden emin misiniz?')) {
      await remove(ref(db, `announcements/${id}`));
    }
  };

  return (
    <>
      <h2 className="admin-page-title">Duyuru Yönetimi</h2>
      <p className="admin-page-sub">{announcements.length} duyuru yayında</p>

      {!adding ? (
        <button className="a-btn a-btn-add" onClick={() => setAdding(true)}>+ Yeni Duyuru Ekle</button>
      ) : (
        <div className="admin-card a-form-card">
          <div className="admin-card-header"><h3>Yeni Duyuru</h3></div>
          <form onSubmit={handleAdd} className="a-form">
            <div className="a-form-group">
              <label>Başlık</label>
              <input
                value={form.title}
                onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
                placeholder="Duyuru başlığını girin"
                required
              />
            </div>
            <div className="a-form-group">
              <label>İçerik</label>
              <textarea
                value={form.body}
                onChange={e => setForm(f => ({ ...f, body: e.target.value }))}
                placeholder="Duyuru içeriğini girin..."
                rows={4}
                required
                className="a-textarea"
              />
            </div>
            <div className="a-form-group a-form-checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={form.important}
                  onChange={e => setForm(f => ({ ...f, important: e.target.checked }))}
                />
                <span>Önemli duyuru olarak işaretle</span>
              </label>
            </div>
            <div className="a-form-actions">
              <button type="submit" className="a-btn a-btn-save" disabled={saving}>
                {saving ? 'Yayınlanıyor...' : 'Yayınla'}
              </button>
              <button type="button" className="a-btn a-btn-cancel" onClick={() => { setAdding(false); setForm({ title: '', body: '', important: false }); }}>
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="a-ann-list">
        {announcements.length === 0 ? (
          <div className="admin-card"><p className="a-empty" style={{ padding: 20 }}>Yayınlanmış duyuru bulunmamaktadır.</p></div>
        ) : announcements.map(a => (
          <div className={`a-ann-card ${a.important ? 'a-ann-important' : ''}`} key={a.id}>
            <div className="a-ann-top">
              <div className="a-ann-title">
                {a.important && <span className="a-ann-badge">Önemli</span>}
                {a.title}
              </div>
              <div className="a-ann-date">{fmt(a.createdAt)}</div>
            </div>
            <div className="a-ann-body">{a.body}</div>
            <div className="a-ann-footer">
              <button className="a-btn a-btn-delete" onClick={() => handleDelete(a.id!)}>Duyuruyu Sil</button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AnnouncementsTab;
